export const MUNDIAL_2026 = 'mundial2026'
export const FASES_DE_GRUPOS = 'GROUP_STAGE'
export const FASE_DE_GRUPOS_2 = 'PHASE_GROUP'
export const DIECISEISAVOS = 'ROUND_OF_32'
export const OCTAVOS = 'ROUND_OF_16'
export const CUARTOS = 'QUARTER_FINALS'
export const SEMIFINAL = 'SEMI_FINALS'
export const TERCER_LUGAR = 'THIRD_PLACE'
export const FINAL = 'FINAL'
export const ELIMINATION_PHASES = [DIECISEISAVOS, OCTAVOS, CUARTOS]
export const matchSchedule = 'SCHEDULED'
export const matchCompleted = 'COMPLETED'
export const matchInProgress = 'IN_PROGRESS'
export const animationDuration = 400
export const PartidosTab = 'partidos'
export const TablaDePosicionesTab = 'tabla-de-posiciones'
export const EstadisticasDeJuegoTab = 'estadísticas-de-juego'
export const PaisesTab = 'paises'
export const PARTIDO_POR_DEFINIR = 'POR DEFINIR'
export const GANADOR = 'GANADOR'
export const PERDEDOR = 'PERDEDOR'
export const SEGUNDO = 'SEGUNDO'
export const TERCERO = 'TERCERO'
export const MINIPLAYER_RETRY_CONFIG_DEFAULT = '{"default": {"attempts": 3},"mexico": {"attempts": 3}}';
export const MINIPLAYER_RETRY_CONFIG = 'miniplayer_retry_config';
export const MINIPLAYER_PLAYBACK_CONFIG_DEFAULT = '{"default":{"play_live_match":{"enable":true,"version":"v1"},"play_comments":false},"argentina":{"play_live_match":{"enable":true,"version":"v1"},"play_comments":false},"mexico":{"play_live_match":{"enable":false,"version":"v2"},"play_comments":true}}';
export const MINIPLAYER_PLAYBACK_CONFIG = 'miniplayer_playback_config';
export const V1PLAYBACKCONFIG = 'v1';
export const V2PLAYBACKCONFIG = 'v2';
export const V3PLAYBACKCONFIG = 'v3';
export const PLAYBACK_AKT_SEED_CONFIG_DEFAULT = '{"default": {"enabled": false}}';


export const MAIN_MENU = [
    {
    id: PartidosTab,
    title: "eventodeportivo_pestanasecciones_texto_partidos",
    icon: "eventodeportivo_pestanasecciones_icono_partidos_sinfoco",
    iconHover: "eventodeportivo_pestanasecciones_icono_partidos_foco"
    },
    {
    id: TablaDePosicionesTab,
    title: "eventodeportivo_pestanasecciones_texto_tablaposiciones",
    icon: "eventodeportivo_pestanasecciones_icono_tablaposiciones_sinfoco",
    iconHover: "eventodeportivo_pestanasecciones_icono_tablaposiciones_foco"
    },
    {
    id: EstadisticasDeJuegoTab,
    title: "eventodeportivo_pestanasecciones_texto_estadisticas",
    icon: "eventodeportivo_pestanasecciones_icono_estadisticas_sinfoco",
    iconHover: "eventodeportivo_pestanasecciones_icono_estadisticas_foco"
    },
    {
    id: PaisesTab,
    title: "eventodeportivo_pestanasecciones_texto_paises",
    icon: "eventodeportivo_pestanasecciones_icono_paises_sinfoco",
    iconHover: "eventodeportivo_pestanasecciones_icono_paises_foco"
    }
]



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/constants.js